import TencentCloudChat from '@tencentcloud/chat';
import TIMUploadPlugin from 'tim-upload-plugin';
import store from '@/store/index'
import TYPES from '@/utils/types'
import {restLogin} from '@/unit/util.js'
import {eltips} from '@/unit/eltips.js'
import router from '@/router/router.js';

const options = {
	SDKAppID: 1600016855
};
export const tim = TencentCloudChat.create(options);
tim.setLogLevel(1); // 0 普通级别，日志量较多，接入时建议使用 生产环境改为1
// 注册 COS SDK 插件
tim.registerPlugin({
	'tim-upload-plugin': TIMUploadPlugin
});

//SDK状态判断
tim.on(TencentCloudChat.EVENT.SDK_READY, setSdkReady);
tim.on(TencentCloudChat.EVENT.SDK_NOT_READY, setSdkReady);

function setSdkReady({name}) {
	const isSDKReady = (name === TencentCloudChat.EVENT.SDK_READY)
	store.commit('changeSdkReady', isSDKReady)
	console.log('---------设置SDK状态---------', isSDKReady)
	if (isSDKReady) {
		tim.getConversationList().then(res => {
			store.commit('updateAllConversation', res.data.conversationList)
			// store.getters.totalUnreadCount
		})
	}
}

//收到消息监听
tim.on(TencentCloudChat.EVENT.MESSAGE_RECEIVED, onMessageReceived)

function onMessageReceived(event) {
	for (let i = 0; i < event.data.length; i++) {
		let item = event.data[i]
		if (item.type === TYPES.MSG_GRP_TIP) {
			if (item.payload.operationType) {
				$bus.$emit('groupNameUpdate', item.payload)
			}
		}
		if (item.type == 'TIMCustomElem' && item.payload.description == 'systemMsg') {
			tim.setMessageRead({
				conversationID: 'C2Cadministrator'
			})
		}
	}
	store.dispatch('onMessageEvent', event)
	// store.getters.totalUnreadCount
}

// 收到会话列表更新通知，可通过遍历 event.data 获取会话列表数据并渲染到页面
tim.on(TencentCloudChat.EVENT.CONVERSATION_LIST_UPDATED, convListUpdate)

function convListUpdate(event) {
	store.commit('updateAllConversation', event.data)
}

// 收到对端已读消息的通知，即已读回执。使用前需要将SDK版本升级至v2.7.0或更高版本。仅支持单聊会话。
tim.on(TencentCloudChat.EVENT.MESSAGE_READ_BY_PEER, onMessageReadByPeer)

function onMessageReadByPeer(event) {
	store.dispatch('onMessageRead', event)
}

// 用户被踢下线时触发
tim.on(TencentCloudChat.EVENT.KICKED_OUT, onKickedOut)

function onKickedOut(event) {
	restLogin()
	router.push({ name: 'Home' });
	eltips('您的账号在其他地方登录，当前账号已下线','error',0)
	// uni.showModal({
	// 	content: '您的账户已在其他地方登录，请重新登录。',
	// 	showCancel: false,
	// 	success: (res) => {
	// 		uni.reLaunch({
	// 			url: '/pages/login/login'
	// 		})
	// 	}
	// })
}
